.container {
    min-height: 100vh;
    background-color: #F7F9FC;
  }
  
  .header {
    background-color: white;
    padding: 20px 0;
    border-bottom: 1px solid #E2E8F0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }
  
  .content {
    max-width: 800px;
    margin: 0 auto;
    padding: 40px 20px;
    background-color: white;
    margin-top: 0;
    margin-bottom: 40px;
    border-radius: 0 0 12px 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  }
  
  .content h1 {
    font-size: 36px;
    font-weight: 700;
    color: #2D3748;
    margin: 0 0 8px 0;
    text-align: center;
  }
  
  .lastUpdated {
    text-align: center;
    color: #718096;
    font-size: 14px;
    margin: 0 0 40px 0;
    font-style: italic;
  }
  
  .section {
    margin-bottom: 32px;
    padding-bottom: 24px;
    border-bottom: 1px solid #EDF2F7;
  }
  
  .section:last-of-type {
    border-bottom: none;
  }
  
  .section h2 {
    font-size: 24px;
    font-weight: 600;
    color: #2D3748;
    margin: 0 0 16px 0;
    padding-bottom: 8px;
    border-bottom: 2px solid #635BFF;
    display: inline-block;
  }
  
  .section h3 {
    font-size: 18px;
    font-weight: 600;
    color: #4A5568;
    margin: 24px 0 12px 0;
  }
  
  .section p {
    font-size: 16px;
    line-height: 1.6;
    color: #4A5568;
    margin: 0 0 16px 0;
  }
  
  .section ul {
    margin: 16px 0;
    padding-left: 24px;
  }
  
  .section li {
    font-size: 16px;
    line-height: 1.6;
    color: #4A5568;
    margin-bottom: 8px;
  }
  
  .contactInfo {
    background-color: #F7FAFC;
    padding: 20px;
    border-radius: 8px;
    border-left: 4px solid #635BFF;
    margin-top: 16px;
  }
  
  .contactInfo p {
    margin: 8px 0;
    font-size: 16px;
  }
  
  .contactInfo strong {
    color: #2D3748;
  }
  
  .footer {
    margin-top: 40px;
    padding-top: 24px;
    border-top: 2px solid #EDF2F7;
    text-align: center;
  }
  
  .backButton {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background-color: #635BFF;
    color: white;
    text-decoration: none;
    padding: 12px 24px;
    border-radius: 8px;
    font-weight: 500;
    transition: all 0.2s ease;
  }
  
  .backButton:hover {
    background-color: #574CE0;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(99, 91, 255, 0.3);
  }
  
  /* Responsive design */
  @media (max-width: 768px) {
    .content {
      padding: 24px 16px;
      margin: 0 16px 24px;
    }
    
    .content h1 {
      font-size: 28px;
    }
    
    .section h2 {
      font-size: 20px;
    }
    
    .section h3 {
      font-size: 16px;
    }
    
    .section p,
    .section li {
      font-size: 14px;
    }
  }